import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
const CustomLoader = ({ color = "inherit", size = 20, sx, }) => {
    return (_jsx(CircularProgress, { color: color, size: size, sx: sx }));
};
export default CustomLoader;
